module.exports = __webpack_public_path__ + "static/media/settings-search-icon.a5804fb6.svg";